import storeE from "../../../store";

export const validateStep2 = () => {
  const newState = storeE.getState();

  const wizard = newState.wizard;
  const val = newState.step2Validation;
  const site = newState.newSite;
  const template = site.Template || {};
  const config = template.config || {};

  const baseValidation =
    wizard.isStepValid &&
    val.PurposeValid.isValid &&
    val.TitleValid.isValid &&
    (config.siteCustomName || val.NameValid.isValid);

  if (template.id === 6) {
    return (
      baseValidation &&
      val.PrefixValid.isValid &&
      val.TreeDigitCodeValid.isValid
    );
  }

  return baseValidation;
};

export const validate2 = () => {
  const newState = storeE.getState();
  const site = newState.newSite;
  return !!site.Title && !!site.Name && !!site.Purpose;
};



// WEBPACK FOOTER //
// ./src/components/CreateSite/Step2/Validator.js